import { mapState } from 'vuex'
import { ossUrl } from '../config/base'

export default {
  data: () => ({
    langs: ['cn', 'en']
  }),
  computed: {
    ...mapState({
      user: state => state.user
    }),
    isAdmin () {
      return _.findIndex(_.get(this.user, 'roles', []), {
        id: 1
      }) > -1
    },
    isMobile () {
      return this.$vuetify.breakpoint.xsOnly
    }
  },
  methods: {
    ossPath (file, hash = true) {
      return ossUrl + file + (hash ? `?v=${_.random(1, 100, true)}` : '')
    },
    can (permission) {
      if (this.isAdmin) {
        return true
      }
      return _.uniq(_.flatten(_.map(_.get(this.user, 'roles', []), 'permissions'))).indexOf(permission) > -1
    },
    canSee (page) {
      if (this.isAdmin) {
        return true
      }
      return _.uniq(_.flatten(_.map(_.get(this.user, 'roles', []), 'paths'))).indexOf(page) > -1
    }
  }
}
